import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import HttpApi from 'i18next-http-backend';
//import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

const localData = localStorage.getItem('localData')

let lang;
if (localData) {
    const localDataParsed = JSON.parse(localData);

    if (new Date(localDataParsed.cookiesPolicy.exp) > new Date()) {
        lang = localDataParsed.UILang;
    } else {
        lang = 'en';
    }
} else {
    lang = 'en';
}

i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
        lng: lang,
        fallbackLng: 'en',
        debug: process.env.NODE_ENV && process.env.NODE_ENV === 'development' ? true : false,
        saveMissing: false,
        react: {
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'pre', 'ul', 'li', 'em', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']
        }
    });

export default i18n;
